import React from 'react';

const SeeMoreButton = ({ onClick }) => {
  return (
    <button type="button" className="link-like ml-2" onClick={onClick}>
      See More
    </button>
  );
};

export default SeeMoreButton;
